import { render, staticRenderFns } from "./professions.vue?vue&type=template&id=35ef84ae&scoped=true"
import script from "./professions.vue?vue&type=script&lang=js"
export * from "./professions.vue?vue&type=script&lang=js"
import style0 from "./professions.vue?vue&type=style&index=0&id=35ef84ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ef84ae",
  null
  
)

export default component.exports